import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">📚 Learning Hub</h1>
        <p className="header-subtitle">Your journey to mastery starts here</p>
      </div>
    </header>
  );
};

export default Header;
